module.exports = __webpack_public_path__ + "static/media/osteomuscular-and-connective-tissue-diseases-icon.65312dc8.svg";